var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowX2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Icon-fill-color",
    stroke: "transparent",
    d: "M12.0021 21.9979C11.4498 21.9979 11.0021 21.5502 11.0021 20.9979L11.0021 5.41636L7.05347 9.36499C6.66294 9.75551 6.02978 9.75551 5.63925 9.36499C5.24873 8.97446 5.24873 8.3413 5.63925 7.95077L11.2961 2.29392C11.4912 2.09882 11.7469 2.00119 12.0026 2.00102C12.2583 2.00115 12.514 2.09878 12.7092 2.29392L18.366 7.95077C18.7566 8.3413 18.7566 8.97446 18.366 9.36499C17.9755 9.75551 17.3423 9.75551 16.9518 9.36499L13.0021 5.41526L13.0021 20.9979C13.0021 21.5502 12.5544 21.9979 12.0021 21.9979Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowX2);
export default __webpack_public_path__ + "static/media/ArrowX2.cb0090abe44ce48e4d2c49199484148c.svg";
export { ForwardRef as ReactComponent };